import { Link } from "react-router-dom";
import { Instagram, MessageCircle, Mail, Heart, Shield } from "lucide-react";
import { useApp } from "@/context/AppContext";
import Logo from "@/components/Logo";

export default function Footer() {
  const { user } = useApp();
  return (
    <footer className="mt-24 border-t bg-background" data-testid="site-footer">
      {/* Marquee */}
      <div className="border-b py-6 marquee">
        <div className="marquee-track font-display text-4xl md:text-6xl font-bold uppercase tracking-tighter">
          {Array.from({ length: 6 }).map((_, i) => (
            <span key={i} className="mx-8 opacity-90">Wear Your Identity · The Fabrics ·</span>
          ))}
        </div>
      </div>

      {/* Hero logo block */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-16 pb-10 flex flex-col items-center text-center">
        <Logo variant="full" className="h-28 md:h-36 w-auto dark:invert" />
        <div className="mt-6 font-display text-xl tracking-[0.35em]">THE FABRICS</div>
        <div className="mt-2 text-[11px] tracking-[0.4em] opacity-60">WEAR YOUR IDENTITY.</div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pb-4 grid grid-cols-2 md:grid-cols-3 gap-10 border-t pt-12">
        <div>
          <div className="label-xs mb-4">Shop</div>
          <ul className="space-y-2 text-sm opacity-80">
            <li><Link to="/shop" className="link-underline">All Products</Link></li>
            <li><Link to="/shop?category=Oversized" className="link-underline">Oversized</Link></li>
            <li><Link to="/shop?category=Heavyweight" className="link-underline">Heavyweight</Link></li>
            <li><Link to="/shop?category=Streetwear" className="link-underline">Streetwear</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-xs mb-4">Support</div>
          <ul className="space-y-2 text-sm opacity-80">
            <li><Link to="/track" className="link-underline">Track Order</Link></li>
            <li><Link to="/contact" className="link-underline">Contact Us</Link></li>
            <li><Link to="/faq" className="link-underline">FAQ</Link></li>
            <li><Link to="/shipping-policy" className="link-underline">Shipping Policy</Link></li>
            <li><Link to="/return-policy" className="link-underline">Return & Refund</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-xs mb-4">Company</div>
          <ul className="space-y-2 text-sm opacity-80">
            <li><Link to="/about" className="link-underline">About Us</Link></li>
            <li><Link to="/privacy-policy" className="link-underline">Privacy Policy</Link></li>
            <li><Link to="/terms" className="link-underline">Terms & Conditions</Link></li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pb-10 grid gap-3 sm:grid-cols-3 text-sm opacity-80 border-t pt-10 mt-4">
        <a href="mailto:thefabrics37@gmail.com" className="flex items-center gap-2 link-underline w-fit" data-testid="footer-email"><Mail className="h-4 w-4"/>thefabrics37@gmail.com</a>
        <a href="https://www.instagram.com/the_fabrics.in" target="_blank" rel="noreferrer" className="flex items-center gap-2 link-underline w-fit" data-testid="footer-instagram"><Instagram className="h-4 w-4"/>@the_fabrics.in</a>
        <div className="flex items-center gap-2 opacity-70"><MessageCircle className="h-4 w-4"/>WhatsApp — tap the floating button</div>
      </div>
      <div className="border-t py-6 text-center text-xs opacity-70">
        © 2026 THE FABRICS. All Rights Reserved.<br className="sm:hidden"/>
        <span className="hidden sm:inline"> · </span>
        Designed with <Heart className="inline h-3 w-3 fill-current mx-1" /> in India.
      </div>
    </footer>
  );
}
